export default __webpack_public_path__ + "static/media/dsaas.c43ef132.svg";